import React, { useState } from "react";
import DataTable from "./DataTable";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import SoftBox from "components/SoftBox";
import Card from "@mui/material/Card"; 
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { ThumbsUp } from "lucide-react";

const TotalUsers = () => {
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(8);
  const [loading, setLoading] = useState(false);
  
  const handleEntriesChange = (newEntries) => {
    setEntriesPerPage(newEntries);
    setPage(1);
  };

  const columns = [
    { Header: "Question", accessor: "content", align: "left" },
    { Header: "IP Address", accessor: "ip_address", align: "left" },
    { Header: "DATE & TIME", accessor: "created_at", align: "left" },
    { Header: "Actions", accessor: "answer", align: "left" },
    // { Header: "Likes", accessor: "likes", align: "left" },
  ];
  
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div style={{ width: "100%", marginTop: "0px"}}>
        <Card>
          <SoftBox p={3} lineHeight={1.2}>
            {loading ? (
              <p style={{ textAlign: "center" }}>Loading data...</p>
            ) : (
              <>
                <DataTable
                  table={{ columns, rows }}
                  entriesPerPage={{
                    defaultValue: entriesPerPage,
                    entries: [5, 10, 15],
                  }}
                  canSearch
                  date
                  csv
                  showTotalEntries
                  onEntriesChange={handleEntriesChange}
                  totalPages
                />  
              </>
            )}
          </SoftBox>
        </Card>
      </div>
    </DashboardLayout>
  );
};
export default TotalUsers;
